import * as LabelPrimitive from '@radix-ui/react-label'
import * as React from 'react'
import { cn } from '../../lib/cn'

/**
 * Label — form field label.
 * Hooks into Radix Label so clicking the label focuses its `htmlFor` target.
 */
export interface LabelProps extends React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> {
  required?: boolean
  hint?: string
}

export const Label = React.forwardRef<React.ElementRef<typeof LabelPrimitive.Root>, LabelProps>(
  ({ className, required, hint, children, ...props }, ref) => (
    <div className="flex items-center justify-between gap-2">
      <LabelPrimitive.Root
        ref={ref}
        className={cn(
          'text-body-sm font-medium text-ia-text leading-none',
          'peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
          className,
        )}
        {...props}
      >
        {children}
        {required && (
          <span className="text-ia-error ml-1" aria-hidden="true">
            *
          </span>
        )}
      </LabelPrimitive.Root>
      {hint && <span className="text-caption text-ia-text-tertiary">{hint}</span>}
    </div>
  ),
)
Label.displayName = 'Label'
